import * as React from 'react';
import _ from 'lodash';
import './dashboard.css';
import { Responsive, WidthProvider } from 'react-grid-layout';
import type { CompactType, Layout, LayoutItem, ReactChildren } from 'react-grid-layout';
import type { Breakpoint, OnLayoutChangeCallback } from 'react-grid-layout';
import Info from '../dashboarders/Info';
import Settings from '../dashboarders/settings';
import TwoD from '../dashboarders/twoD';
import ThreeD from '../dashboarders/nThreeD';
import Poi from '../dashboarders/pointsofinterest';
import ThreeDataPanels from '../dashboarders/threeDatapanels';
import OneDataPanel from '../dashboarders/oneDatapanel';
import Experimental from '../dashboarders/experimental';

const ResponsiveReactGridLayout = WidthProvider(Responsive);
const availableHandles = ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'];

const defaultProps = {
  className: 'layout',
  rowHeight: 30,
  onLayoutChange: function () {},
  cols: { lg: 3, md: 3, sm: 1, xs: 1, xxs: 1 },
};

const CustomDashboard = (props) => {
    const [currentBreakpoint, setCurrentBreakpoint] = React.useState('lg');
    const [compactType, setCompactType] = React.useState('vertical');
    const [mounted, setMounted] = React.useState(false);
    const [resizeHandles, setResizeHandles] = React.useState(['se']);
    const [texture, setTexture] = React.useState(null);
    const components = [];

    const layouts ={ 
        sm: [],
        md: [],
        lg: [],
    };

  const addComponent = (i, sx, mx, sy, my, sw, mw, sh, mh, content)=>{
        layouts.sm.push({i, x: sx, y: sy, w: sw, h:sh});
        let mandl = {i, x: mx, y: my, w: mw, h:mh}
        layouts.md.push(mandl);
        layouts.lg.push(mandl)
        components.push(<div key={i} style={{overflow: "auto"}}>{content?content:i}</div>)
    }

    const init = ()=>{
        
        addComponent("TwoD", 0, 0, 0, 1, 3, 1, 18, 18, <TwoD onTextureReady={setTexture}  />);
        addComponent("Settings", 0, 0, 0, 1, 3, 1, 10, 10, <Settings />);
        addComponent("Poi", 0, 0, 0, 1, 3, 1, 10, 10, <Poi />);
        
        addComponent("ThreeD", 0, 1, 0, 0, 3, 2, 10, 24, <ThreeD texture={texture} />);
        addComponent("Info", 10, 0, 0, 3, 3, 1, 10, 8, <Info />);
        addComponent("ThreeDP", 0, 1, 0, 1, 3, 2, 10, 18, <ThreeDataPanels />);
        
    }

    init();

    

  React.useEffect(() => {
    setMounted(true);
  }, []);

  const onBreakpointChange = (breakpoint) => {
    setCurrentBreakpoint(breakpoint);
  };

  const onCompactTypeChange = () => {
    const newCompactType =
      compactType === 'horizontal' ? 'vertical' : compactType === 'vertical' ? null : 'horizontal';
    setCompactType(newCompactType);
  };

  const onResizeTypeChange = () => {
    // const newResizeHandles = resizeHandles === availableHandles ? ['se'] : availableHandles;
    // setResizeHandles(newResizeHandles);
    // setLayouts({ lg: generateLayout(newResizeHandles) });
  };

  const onLayoutChange = (layout, layouts) => {
    props.onLayoutChange(layout, layouts);
  };

  const onNewLayout = () => {
    // setLayouts({ lg: generateLayout(resizeHandles) });
  };

  const onDrop = (elemParams) => {
    alert(`Element parameters: ${JSON.stringify(elemParams)}`);
  };

  const generateDOM = () => {
    return _.map(layouts.lg, (l, i) => (
      <div key={i} style={{ background: 'grey' }} className={l.static ? 'static' : ''}>
        {l.static ? (
          <span className="text" title="This item is static and cannot be removed or resized.">
            Static - {i}
          </span>
        ) : (
          <span className="text">{i}</span>
        )}
      </div>
    ));
  };

  const generateDOMC = () => {
    return _.map(components, (c, i)=>c);
    // return (
    //     <div key="Info" style={{background: "grey"}}>  helloi </div>
        
    // )

}

  return (
    <div>
      <ResponsiveReactGridLayout
        {...props}
        layouts={layouts}
        onBreakpointChange={onBreakpointChange}
        onLayoutChange={onLayoutChange}
        onDrop={onDrop}
        measureBeforeMount={false}
        useCSSTransforms={mounted}
        compactType={compactType}
        draggableHandle=".react-grid-dragHandleExample"
        preventCollision={!compactType}>
        {generateDOMC()}
      </ResponsiveReactGridLayout>
    </div>
  );
};

CustomDashboard.defaultProps = defaultProps;

export default CustomDashboard;
